
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class extends Vue {
  @Prop({ default: [] }) ruleList!: []; // 积分规则列表
}
